module.exports = __webpack_public_path__ + "static/em101_cover.365986a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/em101_cover.png
// module id = 3092
// module chunks = 226605119891641